import { SVGProps } from "react";

const STIThisamericanlife = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="This American Life" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><path d="M90 170v98h117v-98zm157.7 0v29.25h175.3v-29.25zm0 69v29.25h175.3v-29.25zm30.3 97.25h145V307H90v29.25H208V420.4z" fill="#ed0017" /></svg>;

export { STIThisamericanlife };